import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import { sendPageView } from "lib/googleAnalytics/page";
import { Container, Row, Col } from "react-bootstrap";
import log from "loglevel";
import { getTheme } from "lib/theme";
import { getDomainName } from "lib/domain";
import { ThemeLogo } from "components/pages/auth/ThemeLogo";
import genStyles from "styles/General.module.scss";
import * as routes from "routes";

const NotFoundPage = () => {
  const history = useHistory();
  const location = useLocation();

  const [theme, setTheme] = useState<string | undefined>();

  useEffect(() => {
    log.info("NotFoundPage useEffect()...");
    setTheme(getTheme());
    log.info(`Domain Name: ${getDomainName()}`);
  }, []);

  /**
   * Google Analytics
   */
  useEffect(() => {
    sendPageView(location.pathname + location.search);
  }, [location]);
  
  const onHandleBackToDashboard = (event: any) => {
    log.info("Going back...");
    event.preventDefault();
    history.goBack();
  };

  return (
    <div id="NotFoundPage" style={{ height: "100%", width: "100%" }}>
      <Container className="h-100" fluid={true} style={{ minWidth: "100%" }}>
        <Row className="h-100 justify-content-md-center align-items-center">
          <Col md="auto" style={{ display: "flex", justifyContent: "center" }}>
            <div className="text-center">
              <div>
                <ThemeLogo theme={theme} />
              </div>
              <h1>PAGE NOT FOUND</h1>
              <input
                type="submit"
                value="Take me back"
                className={genStyles["alenza__btn-primary"]}
                onClick={(e: any) => onHandleBackToDashboard(e)}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NotFoundPage;
